var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 4.5H5.625V7.875H12.375V4.5Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 15.188V2.81299C14.625 2.50233 14.3732 2.25049 14.0625 2.25049L3.9375 2.25049C3.62684 2.25049 3.375 2.50233 3.375 2.81299V15.188C3.375 15.4986 3.62684 15.7505 3.9375 15.7505H14.0625C14.3732 15.7505 14.625 15.4986 14.625 15.188Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 11.25C6.65349 11.25 7.03125 10.8722 7.03125 10.4062C7.03125 9.94026 6.65349 9.5625 6.1875 9.5625C5.72151 9.5625 5.34375 9.94026 5.34375 10.4062C5.34375 10.8722 5.72151 11.25 6.1875 11.25Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 14.0625C6.65349 14.0625 7.03125 13.6847 7.03125 13.2188C7.03125 12.7528 6.65349 12.375 6.1875 12.375C5.72151 12.375 5.34375 12.7528 5.34375 13.2188C5.34375 13.6847 5.72151 14.0625 6.1875 14.0625Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.25C9.46599 11.25 9.84375 10.8722 9.84375 10.4062C9.84375 9.94026 9.46599 9.5625 9 9.5625C8.53401 9.5625 8.15625 9.94026 8.15625 10.4062C8.15625 10.8722 8.53401 11.25 9 11.25Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14.0625C9.46599 14.0625 9.84375 13.6847 9.84375 13.2188C9.84375 12.7528 9.46599 12.375 9 12.375C8.53401 12.375 8.15625 12.7528 8.15625 13.2188C8.15625 13.6847 8.53401 14.0625 9 14.0625Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 11.25C12.2785 11.25 12.6562 10.8722 12.6562 10.4062C12.6562 9.94026 12.2785 9.5625 11.8125 9.5625C11.3465 9.5625 10.9688 9.94026 10.9688 10.4062C10.9688 10.8722 11.3465 11.25 11.8125 11.25Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 14.0625C12.2785 14.0625 12.6562 13.6847 12.6562 13.2188C12.6562 12.7528 12.2785 12.375 11.8125 12.375C11.3465 12.375 10.9688 12.7528 10.9688 13.2188C10.9688 13.6847 11.3465 14.0625 11.8125 14.0625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.3ef0fca55411e14f37288ddfd7af7835.svg";
export { ForwardRef as ReactComponent };